"use client";

import React, { createContext, useContext } from 'react';
import { useSite } from "@/lib/hooks/site";
import getTDefaultOptions from "@/app/i18n/utilts";
import { initReactI18next } from 'react-i18next';
import i18next from "i18next";
import { getOptions } from '@/app/i18n/settings';
import { useTranslation as useTranslationOrg } from "react-i18next";

export const TranslationContext = createContext(null);

i18next
  .use(initReactI18next)
  // .use(LanguageDetector)
  .init({
    ...getOptions(),
    lng: "tr",
    detection: {
      order: ["path", "htmlTag", "cookie", "navigator"],
    },
    resources: {
      tr: {
        site: {
          "close-venues-title": "as"
        }
      }
    },
    interpolation: {
      escapeValue: false,
    },
  });

export const TranslationProvider = ({ children, keys }) => {
  const domain = typeof window !== "undefined" ? window.location.hostname : "";
  const isTemplateApp = domain.includes("template-app");

  const site = useSite();
  const ret = useTranslationOrg("site", {})
  const { i18n, t: originalT } = ret;

  if (keys && typeof keys === 'object') {
    i18next.addResources("tr", 'site', keys);
  }

  const newT = (key, options = {}) => {
    if (isTemplateApp) return key;

    const tOptions = getTDefaultOptions(key, options, site);

    return originalT(key, tOptions);
  };

  const values = {
    t: newT,
    i18n,
  };

  return (
    <TranslationContext.Provider value={values}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => {
  return useContext(TranslationContext);
};